import _ from 'lodash';
import ErrorText from './ErrorText';



//process the raw data to send it back to the server in proper json format to save in master devices
export default function (data) {
let someData = someValue(data);
return someData
}

const someValue = (data) =>{
	let someData = [];

	data.forEach((outerElement1, index)=>{
		if(outerElement1.paramValues.length!==0){
			someData = {
				...someData,
				[outerElement1.paramField]: someValue((outerElement1.paramValues))
			}
         // someData.push( [outerElement1.paramField]: someValue((outerElement1.paramValues)))
      }else if(outerElement1.paramValues.length===0){
        someData.push(outerElement1.paramField)
      }
   })
   return someData
}

const updatePath = (data) => {
	let processedData = data;
	data.forEach((outerElement, index) => {
		let indexOfString = outerElement.path.lastIndexOf("/");
		let prefixPath = outerElement.path.slice(0,indexOfString+1)
		let changingPath = outerElement.path.slice(indexOfString+1)
		if(changingPath!==index){
			let newPath = prefixPath + String(index);
			processedData[index].path = newPath
		}
		if(outerElement.paramValues.length!==0){
			updatePath(outerElement.paramValues)
		}
	})
	return processedData
}